import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DocumentFlowDialogComponent } from './document-flow-dialog/document-flow-dialog.component';
import { AuthService } from '../../../abstraction/auth.service';
import { DOCUMENT_STATUS, DOCUMENT_TYPE } from '../../../models/User';

@Component({
  selector: 'app-arbitrage',
  templateUrl: './arbitrage.component.html',
  styleUrls: ['./arbitrage.component.scss'],
})
export class ArbitrageComponent implements OnInit {
  constructor(private dialog: MatDialog, public authService: AuthService) {}

  ngOnInit(): void {}

  showUploadButton(): boolean {
    return Object.entries(this.authService.loggedUser.fundsDocuments).some((docStatus) => {
      return (
        docStatus[0] !== 'selfie' &&
        (docStatus[1] === DOCUMENT_STATUS.NOT_UPLOADED || docStatus[1] === DOCUMENT_STATUS.REJECTED)
      );
    });
  }

  getDocumentStatus(status: DOCUMENT_STATUS) {
    switch (status) {
      case DOCUMENT_STATUS.PENDING:
        return 'Validando';
      case DOCUMENT_STATUS.REJECTED:
        return 'Rechazado';
      case DOCUMENT_STATUS.VALIDATED:
        return 'Aprobado';
      case DOCUMENT_STATUS.NOT_UPLOADED:
        return 'No enviado';
    }
  }

  getDocumentStatusClass(status: DOCUMENT_STATUS) {
    switch (status) {
      case DOCUMENT_STATUS.PENDING:
        return 'pending';
      case DOCUMENT_STATUS.REJECTED:
        return 'rejected';
      case DOCUMENT_STATUS.VALIDATED:
        return 'aproved';
      case DOCUMENT_STATUS.NOT_UPLOADED:
        return 'not-uploaded';
    }
  }

  openDocumentFlowDialog() {
    this.dialog.open(DocumentFlowDialogComponent, {
      backdropClass: 'dialog-primary-backdrop',
      panelClass: 'document-flow-modal',
      maxWidth: '530px',
      width: '40%',
      minWidth: 'fit-content',
      disableClose: true,
    });
  }
}
